<template>
  <td
    :style="
      iteration == 0 ? { 'text-align': 'left' } : { 'text-align': 'right' }
    "
    :class="format"
  >
    {{ isNaN(value) ? clearCase(value) : value }}
  </td>
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    format: "",
    iteration: { default: 0 },
    value: { default: "Data Table Detail Not Set" },
  },
};
</script>